// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4aedec35","453":"86aa2933","732":"e2667b93"}[chunkId] + ".chunk.js";
};